/**
 * aria-label for the "Resend email" button. Stays stable during cooldown
 * so SRs don't announce a per-second countdown; sighted users still see
 * the ticking `(Ns)` via an aria-hidden sibling span.
 */
export const getResendAriaLabel = ({
  isResending,
  isCoolingDown,
}: {
  isResending: boolean;
  isCoolingDown: boolean;
}): string | undefined => {
  if (isResending) {
    return 'Sending verification email';
  }
  if (isCoolingDown) {
    return 'Resend email, temporarily unavailable';
  }

  return undefined;
};
